import { color, TZABrandGuidelines, useResizeObserver } from '@my/util'
import { YStack, XStack, SimpleText, XPProgressBar } from '@my/ui'
import { shadowGenerator } from '../../../../utils/commonStyles'

// ProgressBar Component: Displays progress for a specific month
const ProgressBar = ({ month, completed, total }: ProgressBarProps) => {
  const [dimensions, dimensionsProps] = useResizeObserver();
  const percentage = ((completed / total) * 100).toFixed(0)

  return (
    <XStack alignItems="center" justifyContent="space-between" padding="$4" width="100%" $platform-web={{ gap: '$11' }}>
      {/* Month Label */}
      <SimpleText fontWeight="600" fontSize={16} color={color.lightGrey}>
        {month}
      </SimpleText>

      {/* Progress Information */}
      <YStack flex={1} mx="$4" width="100%" {...dimensionsProps}>
        <XStack justifyContent="space-between">
          <SimpleText color={color.tzaGreen} fontSize={14} fontWeight="500" mb="$2">
            {completed}/{total} Tasks Completed
          </SimpleText>
          <SimpleText fontWeight="700" fontSize={14} color={color.grey}>
            {percentage}%
          </SimpleText>
        </XStack>
        {/* Progress Bar */}
        <XPProgressBar 
          value={+percentage}
          primaryColor={TZABrandGuidelines.colorsMap.primaryGreen}
          //secondaryColor={TZABrandGuidelines.colorsMap.secondaryMustard}
          height={11}
        />
      </YStack>
    </XStack>
  )
}

// TaskProgressList Component: Renders a list of progress bars
export const TaskProgressList = ({ data }: TaskProgressListProps) => {
  return (
    <YStack backgroundColor="#fff" borderRadius="$4" width="100%" {...shadowGenerator(0.2)}>
      {data.map((progressItem, index) => (
        <ProgressBar
          key={index}
          month={progressItem.month}
          completed={progressItem.completed}
          total={progressItem.total}
        />
      ))}
    </YStack>
  )
}
